{
  "header": {
    "title": "Aperçus des leaders",
    "description": "Plongez dans les retours des différents leaders",
    "exportButton": "Exporter"
  },
  "emptyState": {
    "company": {
      "title": "Aucune donnée collectée pour le moment",
      "description": "Votre parcours commence ici ! Une fois que les employés commenceront à partager leurs retours durant le premier mois, vous verrez apparaître des aperçus et des tendances."
    },
    "directReports": {
      "title": "Pas de rapports directs",
      "description": "Vous n'avez aucun rapport direct assigné, mais vous pouvez toujours participer aux enquêtes et partager des retours précieux !",
      "bottomAction": {
        "label": "Si vous pensez que c'est une erreur, contactez votre responsable",
        "helpText": "Texte d'aide"
      }
    }
  },
  "datePicker": {
    "currentMonth": "Ce mois-ci",
    "lastMonth": "Le mois dernier",
    "monthCount": "Il y a {{monthCount}} mois"
  },
  "leaderDropdown": {
    "triggerLabel": "Leader",
    "searchPlaceholder": "Trouver un leader"
  },
  "columnDropdown": {
    "triggerLabel": "Colonnes",
    "options": {
      "showAll": "Afficher toutes les colonnes",
      "hideAll": "Masquer toutes les colonnes"
    }
  },
  "departmentDropdown": {
    "triggerLabel": "Département"
  },
  "tabs": {
    "allReports": "Tous les rapports",
    "directReports": "Rapports directs"
  },
  "columns": {
    "leaderName": "Nom du leader",
    "department": "Département",
    "averageScore": "Score moyen",
    "enps": "eNPS",
    "reportCount": "Nombre de rapports",
    "participationRate": "Taux de participation"
  },
  "loadMoreButton": "Chargement de plus de données",
  "labels": {
    "leader": "Leader",
    "noResults": "Aucun résultat"
  },
  "help": {
    "noResults": "Aucun résultat trouvé"
  },
  "detailsPage": {
    "header": {
      "name": "Équipe de {{name}}",
      "department": "Équipe de {{department}}",
      "backButton": "Retour aux aperçus des leaders",
      "seeProfileButton": "Voir le profil",
      "exportButton": "Exporter"
    },
    "tabs": {
      "allReports": "Tous les rapports",
      "directReports": "Rapports directs"
    },
    "leaderMetrics": {
      "title": "Métriques du leader",
      "category": {
        "enps": {
          "name": "eNPS",
          "helpText": "Texte d'aide"
        },
        "averageScore": {
          "name": "Score moyen",
          "helpText": "Texte d'aide"
        },
        "participationRate": {
          "name": "Taux de participation de l'équipe",
          "helpText": "Texte d'aide"
        }
      },
      "chart": {
        "title": "Score de satisfaction au travail"
      }
    },
    "teamMetrics": {
      "title": "Métriques moyennes de l'équipe",
      "scoreTitle": "Équipe de {{name}}",
      "companyAverageTitle": "Moyenne de l'entreprise"
    },
    "keysInsights": {
      "title": "Principaux insights",
      "strengths": {
        "title": "Forces",
        "tooltipTitle": "Texte d'aide"
      },
      "growthAreas": {
        "title": "Axes de croissance",
        "tooltipTitle": "Texte d'aide"
      }
    },
    "directReport": {
      "title": "Leaders des rapports directs",
      "empty": {
        "title": "Aucun leader en rapport direct",
        "description": "Ce leader n’a aucun leader subordonné, ou les données ne se sont pas encore chargées."
      }
    }
  }
}
